<template>
  <ul class="lang">
    <li class="lang-item"><a class="lang-link" :class="{ 'active': $store.state.lang == 'es'}" href="" @click.prevent="selectLang('es')">Español</a></li>
    <!-- <li class="lang-item"><a class="lang-link" :class="{ 'active': $store.state.lang == 'ay'}" href="" @click.prevent="selectLang('ay')">Aymara</a></li>
    <li class="lang-item"><a class="lang-link" :class="{ 'active': $store.state.lang == 'en'}" href="" @click.prevent="selectLang('en')">English</a></li> -->
    <!-- <li class="lang-item"><a class="lang-link" :class="{ 'active': $store.state.lang == 'fr'}" href="" @click.prevent="selectLang('fr')">Français</a></li> -->
  </ul>
</template>

<script>

import spanish from 'vee-validate/dist/locale/es';
import french from 'vee-validate/dist/locale/fr';

import es from '@/lang/es/messages';
import en from '@/lang/en/messages';
import fr from '@/lang/fr/messages';
import ay from '@/lang/ay/messages';

export default {
  created () {
    let lang = this.$storage.get('lang') || 'es';

    this.$validator.localize('en', {
      attributes: en.fields
    });

    this.$validator.localize('es', {
      messages: spanish.messages,
      attributes: es.fields
    });

    this.$validator.localize('fr', {
      messages: french.messages,
      attributes: fr.fields
    });

    this.$validator.localize('ay', {
      messages: ay.messages,
      attributes: ay.fields
    });

    this.selectLang(lang);
  },
  methods: {
    selectLang (lang) {
      this.$store.commit('setLang', lang);
      this.$i18n.locale = lang;
      this.$storage.set('lang', lang);
      this.$validator.localize(lang);
    }
  }
};
</script>

<style lang="scss">
@import '../../assets/scss/_variables.scss';

.lang {
  position: absolute;
  top: 15px;
  right: 20px;
  list-style: none;
  margin: 0;
  padding: 0;

  .lang-item {
    display: inline-block;
  }

  .lang-link {
    padding: 0.3rem 0.7rem;
    display: block;
    color: white;
    background-color: lighten($primary, 40%);
    font-size: 0.85rem;

    &.active, &:hover {
      background-color: $primary;
      text-decoration: none;
    }
  }
}
@media (max-width: 768px) {
  .lang {
    position: static;
    margin: 0 0 20px 0;
    text-align: center;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/util/Lang.vue